import { render, staticRenderFns } from "./PracticeEditModal.vue?vue&type=template&id=024371fa&"
import script from "./PracticeEditModal.vue?vue&type=script&lang=js&"
export * from "./PracticeEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports